import * as React from "react";

function ChevronLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "5.87799999 7.952 11.178 13.252 10.471 13.959 4.46399998 7.952 10.475 1.94199996 11.182 2.64899997"
  }));
}

export default ChevronLeftIcon;